<template>
    <div>
        <v-img width="100%" src="../assets/paginaInicial.png"></v-img>
        <iframe src="https://www.intelitetecnologia.com.br/giftlist" width="100%" height="1000" frameborder="0" scrolling="no"></iframe>
        <div class="whatsappIcon">
            <a target="_blank" href="https://wa.me/5583988196530?text=Olá, tenho interesse no Gift List e gostaria de tirar dúvidas." style="text-decoration: none">
                <!-- <img height="60" src="../assets/whatsapp.png"/> -->
                <v-icon size="60" color="success" left>mdi-whatsapp</v-icon>
            </a>
        </div>
    </div>
</template>
  
<script>
    export default {
  
    }
</script>
  
<style>
    .whatsappIcon {
        position: fixed;
        bottom: 10px;
        right: 0px;
        clear: both;
    }

    .whatsappIcon img:hover {
        transition: 0.4s;
        -webkit-transform: scale(1.2);
        -moz-transform: scale(1.2);
        -o-transform: scale(1.2);
        -ms-transform: scale(1.2);
        transform: scale(1.2);
    }

    .whatsappIcon img {
        transition: 0.4s;
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        -o-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }
</style>